import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import {
  Inbox as InboxIcon,
  Search as SearchIcon,
  FilterList as FilterIcon
} from '@mui/icons-material';

const EmptyState = ({
  icon: CustomIcon,
  title,
  message,
  actionLabel,
  onAction,
  type = 'default'
}) => {
  const getDefaultIcon = () => {
    if (type === 'search') return <SearchIcon sx={{ fontSize: 64 }} />;
    if (type === 'filter') return <FilterIcon sx={{ fontSize: 64 }} />;
    return <InboxIcon sx={{ fontSize: 64 }} />;
  };

  const Icon = CustomIcon || getDefaultIcon();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        textAlign: 'center'
      }}
    >
      <Box sx={{ color: 'text.secondary', mb: 2 }}>
        {Icon}
      </Box>
      <Typography variant="h6" color="text.primary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
        {message}
      </Typography>
      {actionLabel && onAction && (
        <Button variant="contained" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
